import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Événementiel', path: '/decoration-evenementielle' },
  { label: 'Intérieur', path: '/decoration-interieur' },
  { label: 'Création 3D', path: '/creation-3d' },
  { label: 'Conseil', path: '/conseil' },
  { label: 'Galerie / Portfolio', path: '/galerie' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const textColor = scrolled ? 'text-brand-anthracite' : 'text-white';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link to="/" className="flex items-center shrink-0">
          <img
            src="https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/59e36d2c26ecf2260a04bff1d16ab4f7.png"
            alt="Ev & Co Design Logo"
            className="h-11 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => {
            const isActive = link.path === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(link.path);
            return (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 relative group ${textColor} hover:text-brand-coral`}
                >
                  {link.label}
                  <span
                    className={`absolute -bottom-1 left-0 h-0.5 bg-brand-coral transition-all duration-300 ${
                      isActive ? 'w-full' : 'w-0 group-hover:w-full'
                    }`}
                  />
                </Link>
              </li>
            );
          })}
        </ul>

        {/* CTA */}
        <Link
          to="/contact"
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium text-white whitespace-nowrap transition-all duration-300 hover:scale-105 shrink-0"
          style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
        >
          <i className="ri-mail-send-line text-sm" />
          Contact / Devis
        </Link>

        {/* Mobile Toggle */}
        <button
          className={`lg:hidden text-2xl cursor-pointer ${textColor}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        } bg-white/97 backdrop-blur-md`}
      >
        <ul className="px-6 py-4 space-y-1">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="block text-sm font-medium py-2.5 px-3 rounded-xl text-brand-anthracite hover:bg-brand-beige hover:text-brand-coral transition-colors"
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li className="pt-2">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium text-white whitespace-nowrap"
              style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
            >
              <i className="ri-mail-send-line" />
              Contact / Devis
            </Link>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;
